import { Box, Grid, Paper, Typography } from "@mui/material";
import { ReactNode } from "react";
import { MonthlyData } from "../types";

interface Props {
  children: (platformTitle: string, platformData: MonthlyData, isSingle: boolean) => ReactNode;
  dataByPlatform: Record<string, MonthlyData | null>;
}

const PLATFORMS = ["TDSP", "Enclave"];

const DualPlatformLayout = ({ children, dataByPlatform }: Props) => {
  const available = PLATFORMS.filter((p) => dataByPlatform[p] != null);
  const isSingle = available.length === 1;

  return (
    <Grid container spacing={2}>
      {available.map((platform) => (
        <Grid item xs={12} lg={isSingle ? 12 : 6} key={platform}>
          <Paper
            elevation={0}
            sx={{
              p: { xs: 1.5, sm: 2 },
              borderRadius: 2,
              border: "1px solid #E8EBF0",
              bgcolor: "#fff",
            }}
          >
            <Typography
              variant="h6"
              fontWeight={800}
              sx={{ mb: 2, color: "#1B2559", borderBottom: "2px solid #3B82F6", pb: 1 }}
            >
              {platform}
            </Typography>
            <Box>{children(platform, dataByPlatform[platform]!, isSingle)}</Box>
          </Paper>
        </Grid>
      ))}
    </Grid>
  );
};

export default DualPlatformLayout;
